import _ from 'lodash';
import Vue from 'vue';

import MenuApi from '@/store/api/menu';
import PageApi from '@/store/api/page';
import TagApi from '@/store/api/tag';

import apolloClient from '@/store/apollo';

// initial state
const state = {
    page: {},
    filters: {
        // <page id>: [
        //     {
        //         // ...
        //     }
        // ]
    },
    pageInfo: {
        // <page id>: {
        //     // ...
        // }
    },
    evaluation: {
        informations: {},
        finished: false
    }
};

// getters
const getters = {
    sections: state => {
        let sections = _.get(state, 'page.sections') || [];
        return _.cloneDeep(sections).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0));
    },
    view: state => state.page.view,
    comments: state => state.page.comments,
    id: state => state.page.id,
    filters: state => _.get(state.filters, state.page.id) || [],
    pageInfo: state => _.get(state.pageInfo, state.page.id),
    evaluation: state => state.evaluation,
    pageEvaluation: state => state.page.evaluations[0],
    member: state => state.page.publisher
};

// mutations
const mutations = {
    addPageToState(state, page) {
        state.page = page;
    },
    updateCategoryPostTeasersLoading(state, { s, value }) {
        Vue.set(state.page.sections[s].teasers, 'loading', value);
    },
    insertCategoryPostTeasers(state, { s, teasers }) {
        Vue.set(state.page.sections[s], 'teasers', teasers);
        if (teasers.pageInfo) Vue.set(state.pageInfo, state.page.id, teasers.pageInfo);
    },
    evaluationReactionInputFieldValue(state, payload) {
        const { value, page, information, reaction, section } = payload;
        // const informations = _.get(section, 'informations', []);
        const sectionIndex = _.findIndex(state.page.sections, ['id', section.id]);
        const informationIndex = _.findIndex(state.page.sections[sectionIndex].informations, ['id', information.id]);
        const reactionIndex = _.findIndex(state.page.sections[sectionIndex].informations[informationIndex].reactions, [
            'id',
            reaction.id
        ]);

        if (!state.evaluation.informations) Vue.set(state.evaluation, 'informations', {});
        if (!state.evaluation.informations[information.id]) Vue.set(state.evaluation.informations, information.id, {});
        if (!state.evaluation.informations[information.id].reactions)
            Vue.set(state.evaluation.informations[information.id], 'reactions', {});

        Vue.set(state.evaluation.informations[information.id], 'answer', reaction.id);
        Vue.set(state.evaluation.informations[information.id].reactions, reaction.id, {});
        Vue.set(state.evaluation.informations[information.id].reactions[reaction.id], 'value', value);
        Vue.set(
            state.page.sections[sectionIndex].informations[informationIndex].reactions[reactionIndex].contents[0],
            'text',
            value
        );
    },
    evaluationFinish(state) {
        Vue.set(state.evaluation, 'finished', true);
    },
    evaluationUnfinish(state) {
        Vue.set(state.evaluation, 'finished', false);
    },
    insertFilters(state, filters) {
        Vue.set(state.filters, state.page.id, filters);
    },
    addFilter(state, filter) {
        const i = _.get(state.filters, `${state.page.id}.length`) || 0;
        Vue.set(state.filters[state.page.id], i, filter);
    },
    updateFilter(state, filter) {
        const i = _.findIndex(state.filters[state.page.id], { key: filter.key });
        Vue.set(state.filters[state.page.id], i, filter);
    },
    insertPageInfo(state, pageInfo) {
        Vue.set(state.pageInfo, state.page.id, pageInfo);
    },
    evaluationSave(state, data) {
        Vue.set(state.evaluation, 'informations', data);
    }
    // insertTagOptions(state, tags) {
    //     Vue.set(state.options.tag, 'items', tags);
    // }
};

// actions
const actions = {
    fetchMenuItem({ commit }, { path, cms }) {
        return MenuApi.fetchItem(path, cms);
        // .then(data => commit('addPageToState', data.page))
    },
    fetchCategoryPostTeasers({ commit }, payload) {
        return PageApi.fetchPagesPaginated(payload);
    },
    fetchCategoryPost({ commit }, payload) {
        return PageApi.fetchPage(payload);
    },
    fetchTagOptions({ commit }, payload) {
        return TagApi.fetchList(payload);
    },
    create({ commit }, categoryPage) {
        return PageApi.create(categoryPage).then(categoryPage => {
            // console.log(categoryPage);
            apolloClient.clearStore();
        });
    }
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
};
